import { PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../../models/UserState";
import { RegistretionVendorPayload } from "../../payload/RegistretionVendorPayload";

const registerVendorFetch = (state: UserState, action: PayloadAction<RegistretionVendorPayload>) => {
    state.isLoading = true;
}

export default registerVendorFetch;